<template>
  <div>
    <Breadcrumbs :type="type" :header="title" :url="url" />
    <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.provience_name" :error="form.errors.provience_name"
            class="pb-8 pr-6 w-full lg:w-1/1" label="Name of Province" required="true"
            placeholder="i.e Lanao Del Sur" />
          <select-input v-model="form.geo_region_id" :error="form.errors.geo_region_id"
            class="pb-8 pr-6 w-full lg:w-1/1" label="Name of Region">
            <option value=null>Select Region</option>
            <option v-for="region in regions" :key="region.id" :value='region.id'>{{ region.region_name }}</option>
          </select-input>
          <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/1"
            label="Code of Province" placeholder="i.e 1001" />
          <text-input v-model="form.latitude" :error="form.errors.latitude" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Latitude" placeholder="i.e 7.12345678" />
          <text-input v-model="form.longitude" :error="form.errors.longitude" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Longitude" placeholder="i.e 124.12345678" />
          <file-input v-model="form.logo" :error="form.errors.logo" class="pb-8 pr-6 w-full lg:w-1/1" type="file"
            accept="image/*" label="Logo" />
          <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status of Province"
            class="pb-8 pr-6 mt-8 w-full lg:w-1/1"></status-toogle-button>
        </div>
        <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { ref, toRefs, inject } from 'vue'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Button from '@/Shared/Button'
import FileInput from '@/Shared/FileInput'
export default {
  props: {
    regions: Array,
  },
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Breadcrumbs,
    StatusToogleButton,
    Button,
    FileInput
  },
  layout: Layout,
  remember: 'form',
  setup(props) {
    const { regions } = toRefs(props)
    const form = useForm({
      provience_name: null,
      geo_region_id: null,
      code: null,
      latitude: null,
      longitude: null,
      status: true,
      logo: null
    })
    // const regions = ref([])
    const type = ref('create')
    const title = ref('Province')
    const url = ref('/backend/provinces')
    const createUrl = ref('')
    const swal = inject('$swal')
    const store = () => {
      swal({
        title: 'Are you sure?',
        text: "You want to proceed with this action",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          form.post(`${url.value}`, { forceFormData: true, })
          swal.fire(
            'Added!',
            'Your infomation has been Added.',
            'success'
          )
        }
      });

    }
    return {
      form,
      regions,
      type,
      title,
      url,
      createUrl,
      store
    }
  }
}
</script>
